export default __webpack_public_path__ + "static/media/182.30025a45.gif";